import * as React from 'react'
import Fade from 'react-reveal/Fade'
import className from 'classnames'
import * as style from './main-badges.module.scss'
import Section from '../../components/common/SectionComponent/Section'
import useBadgesQueryHook from '../../hooks/query/useBadgesQueryHook'
import keyGenerator from '../../utils/keyGenerator'

const MainBadges = ({ title, description }) => {
  const badgesData = useBadgesQueryHook()
  return (
    <Section
      hideText={!title && !description}
      title={title}
      newClass={style.badges}
    >
      {description && (
        <p
          className={className('text-color__gray--on-dark', style.description)}
        >
          {description}
        </p>
      )}
      <Fade bottom cascade>
        <div className={style.wrap}>
          {badgesData.map((elem, index) => (
            <div
              key={keyGenerator(index, elem.sourceUrl)}
              className={style.item}
            >
              {elem.localFile && (
                <img
                  loading="lazy"
                  width="150"
                  height="150"
                  alt={elem.localFile.name}
                  title={elem.localFile.name}
                  src={elem.sourceUrl}
                />
              )}
            </div>
          ))}
        </div>
      </Fade>
    </Section>
  )
}

export default MainBadges
